<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <div style="font-size:28px;margin-bottom:20px;margin-left:20px">提交阶段性报告</div>
              <el-form :model="reportForm"
                       :inline="true"
                       :rules="rules2"
                       ref="reportRef"
                       label-width="150px"
                       class="demo-ruleForm"
                       style="width:96%">
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="报告类型">
                      <el-radio-group v-model="reportForm.report_type">
                        <el-radio :label="3"
                                  border>普通报告</el-radio>
                        <el-radio :label="2"
                                  border>阶段性报告</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="阶段选择"
                                  v-if="reportForm.report_type == 2"
                                  prop="subType">
                      <template v-if="reportList.length > 0">
                        <el-radio-group v-model="reportForm.subType"
                                        @change="selSubType">
                          <el-radio-button :label="index"
                                           v-for="(item,index) in reportList"
                                           :key="index">{{item.title}}</el-radio-button>
                        </el-radio-group>
                      </template>
                      <template v-else>
                        <span style="color:red">当前暂无可提交的阶段性报告</span>
                      </template>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="报告摘要"
                                  prop="summary">
                      <el-input type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="reportForm.summary"
                                style="width:680px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="具体实施"
                                  prop="implementation">
                      <el-input type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="reportForm.implementation"
                                style="width:680px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="总结活动准备"
                                  prop="preparation">
                      <el-input type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="reportForm.preparation"
                                style="width:680px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="总结活动执行"
                                  prop="execution">
                      <el-input type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="reportForm.execution"
                                style="width:680px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="筛查人数"
                                  prop="report_screen_number">
                      <el-input placeholder="请输入内容"
                                v-model="reportForm.report_screen_number"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="筛查名单excel"
                                  required>
                      <el-upload class="upload-demo"
                                 :action="uploadFileUrl"
                                 :on-success="onSuccess1"
                                 :before-upload="beforeUploadExcel"
                                 :limit="1"
                                 :on-remove="handleRemove">
                        <el-button size="small"
                                   type="primary">点击上传</el-button>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="项目附件"
                                  required>
                      <el-upload class="upload-demo"
                                 :action="uploadFileUrl"
                                 :on-success="progressOnSuccess"
                                 :limit="1"
                                 :on-remove="handleProgressRemove">
                        <el-button size="small"
                                   type="primary">点击上传</el-button>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="开展细项："
                                  required>
                      <div class="edit_container"
                           style="margin-left:150px">
                        <!-- <quill-editor v-model="reportForm.development_item" ref="myQuillEditor" class="editer" :options="editorOption">
                        </quill-editor>-->
                        <ueditor :defaultMsg="defaultMsg1"
                                 :config="config"
                                 ref="development"></ueditor>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="典型案例："
                                  required>
                      <div class="edit_container"
                           style="margin-left:150px">
                        <!-- <quill-editor v-model="reportForm.cases" ref="myQuillEditor" class="editer" :options="editorOption"> -->
                        <!-- </quill-editor> -->
                        <ueditor :defaultMsg="defaultMsg2"
                                 :config="config"
                                 ref="cases"></ueditor>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="盖章扫描件集合"
                                  required>
                      <el-upload ref="imgUploads"
                                 :action="uploadImgUrl"
                                 list-type="picture-card"
                                 :on-preview="handlePictureCardPreview"
                                 :on-success="onSuccess2"
                                 :data="uploadParms"
                                 name="img"
                                 :on-remove="delPic"
                                 :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-dialog :visible.sync="dialogVisible"
                           append-to-body>
                  <img width="100%"
                       :src="dialogImageUrl"
                       alt />
                </el-dialog>

                <el-form-item style="float:right">
                  <el-button @click="backList">返回页面</el-button>
                  <el-button type="primary"
                             @click="submitForm">立即提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import ueditor from "@/components/ueditor.vue";
// import { quillEditor } from 'vue-quill-editor' //调用编辑器
import myHead from "../public/head";
import centerHead from "../public/center_head";
import leftMenu from "../public/menu";
import footDiv from "../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    ueditor
    // quillEditor
  },
  data () {
    return {
      defaultMsg1: "", // 富文本框默认内容  开展细项
      defaultMsg2: "", // 富文本框默认内容  典型案例
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 300,
        scaleEnabled: true
      },
      //    editorOption: {},  //富文本编辑器
      reportForm: {
        report_type: 3, //报告类型
        //    subType:0,//第几阶段
        development_item: null,
        report_quarter: null,
        report_year: null,
        cases: null
      }, //阶段性报告

      reportList: [],

      uploadFileUrl: "", //上传链接
      uploadImgUrl: "", //图片上传链接
      dialogVisible: false, //查看多图弹框
      dialogImageUrl: null, //当前大图url
      reportImgArr: [], //图片盖章集
      uploadParms: { file_type: 2 }, //图片上传所需参数

      rules2: {
        report_screen_number: [
          { required: true, message: "筛查人数不能为空", trigger: "blur" }
        ],
        summary: [
          { required: true, message: "报告摘要不能为空", trigger: "blur" }
        ],
        implementation: [
          { required: true, message: "具体实施不能为空", trigger: "blur" }
        ],
        preparation: [
          { required: true, message: "总结活动准备不能为空", trigger: "blur" }
        ],
        subType: [
          { required: true, message: "阶段不能为空", trigger: "change" }
        ]
      }
    };
  },

  watch: {},
  methods: {
    backList () {
      //返回到列表页面
      this.$router.push("cfProjectList");
    },

    handlePictureCardPreview (file) {
      //预览图片
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    selSubType (val) {
      this.reportForm.report_year = this.reportList[val].report_year;
      this.reportForm.report_quarter = this.reportList[val].report_quarter;
    },
    getReport (pid) {
      //获取待提交报告列表
      this.$db
        .post(this.$db.config.getCfProReportList1, { project_id: pid })
        .then(res => {
          if (res.code == 200) {
            this.reportList = res.data;
            this.defaultMsg1 = this.reportList.development_item;
            this.defaultMsg2 = this.reportList.cases;
          }
        });
    },

    submitForm () {
      //提交申请

      this.reportForm.development_item = this.$refs[
        "development"
      ].getUEContent();
      this.reportForm.cases = this.$refs["cases"].getUEContent();

      if (this.reportForm.report_type == 3) {
        this.reportForm.report_year = null;
        this.reportForm.report_quarter = null;
      }

      if (!this.reportForm.report_screen_list_file_id) {
        return this.$message.error("请上传筛查名单！");
      }

      if (!this.reportForm.development_item) {
        return this.$message.error("请填写开展细项！");
      }

      if (!this.reportForm.cases) {
        return this.$message.error("请填写典型案例！");
      }
      if (!this.reportForm.progress_file_id) {
        return this.$message.error("请上传项目附件！");
      }
      if (!(this.reportImgArr.length > 0)) {
        return this.$message.error("请上传扫描件集合！");
      } else {
        this.reportForm.report_stamp_pic = this.reportImgArr;
      }

      let data = []; //提交阶段性报告页面

      this.$refs["reportRef"].validate(valid => {
        if (valid) {
          this.$db
            .post(this.$db.config.submitCfProReport, this.reportForm)
            .then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.$router.push({ name: "cfProjectList" });
              } else {
                return this.$message.error(res.msg);
              }
            });
        } else {
          return this.$message.error("请填写完整报告表单信息！");
        }
      });
    },
    //图片上传前操作
    beforeUpload (file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },
    beforeUploadExcel (file) {
      let bool = this.$fnc.checkUploadFile(file, ["xls", "xlsx"]);
      return bool;
    },

    onSuccess2 (response, file, fileList) {
      //图片赋值
      let imgArr = [];
      for (const key in fileList) {
        if (fileList[key].hasOwnProperty("response")) {
          imgArr.push(fileList[key].response.data.id);
        } else {
          imgArr.push(fileList[key].id);
        }
        this.reportImgArr = imgArr;
      }
    },
    delPic (file, fileList) {
      let index = this.reportImgArr.indexOf(file.response.data.id);
      if (index > -1) {
        this.reportImgArr.splice(index, 1);
      }
    },

    progressOnSuccess (response, file, fileList) {
      this.$set(this.reportForm, "progress_file_id", response.data.id);
    },

    handleProgressRemove (file, fileList) {
      this.reportForm.progress_file_id = null;
    },

    onSuccess1 (response, file, fileList) {
      this.$set(
        this.reportForm,
        "report_screen_list_file_id",
        response.data.id
      );
    },
    handleRemove (file, fileList) {
      this.reportForm.report_screen_list_file_id = null;
    }
  },
  created () {
    if (this.$route.query.pid) {
      this.getReport(this.$route.query.pid);
      this.reportForm.project_id = this.$route.query.pid;
      this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
      this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    } else {
      this.$router.push({ name: "cfProjectList" });
    }
  }
  //    computed: {
  //     editor(){
  //         return this.$refs.myQuillEditor.quill
  //     }
  //    },
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

//   .edit_container /deep/ .ql-editor{
//     min-height: 200px !important;
//     margin:0 auto;
//   }

.edit_container {
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/report.vue